interface Environment {
  API_BASE_URL_V1: string;
  API_BASE_URL_V2: string;
  API_BASE_URL_V3: string;
  API_BASE_URL_CATEGORIES: string;
  API_BASE_URL_ONBOARDING: string;
  WEBSITE_BASE_URL: string;
  WEBAPP_BASE_URL: string;
  THANK_YOU_PAGE: string;
  AUTH_APP_URL: string;
  FIREBASE_CONFIG: Record<string, string>;
  SENTRY_ENV_NAME: string;
  // Clearout Form Guard widget. Empty means the widget is not loaded at all.
  CLEAROUT_WIDGET_ID: string;
}

// Staging and local have no Form Guard of their own yet. Set
// REACT_APP_CLEAROUT_WIDGET_ID once a second widget exists in the dashboard;
// until then those environments simply do not load the script.
const CLEAROUT_WIDGET_ID_NON_PROD = process.env.REACT_APP_CLEAROUT_WIDGET_ID ?? '';

const environments: { [key: string]: Environment } = {
  local: {
    API_BASE_URL_V1: 'http://127.0.0.1:8000/api/v1/',
    API_BASE_URL_V2: 'http://localhost:5004/v1/',
    API_BASE_URL_V3: 'http://localhost:5004/v2/',
    API_BASE_URL_CATEGORIES: 'http://localhost:5001/',
    API_BASE_URL_ONBOARDING: 'http://localhost:5002/api/',
    WEBSITE_BASE_URL: 'https://italian-artisan.com/',
    WEBAPP_BASE_URL: 'http://localhost:4200/',
    THANK_YOU_PAGE: 'https://italian-artisan.com/custom-signup-thank-you-page/',
    AUTH_APP_URL: 'http://localhost:3000/',
    FIREBASE_CONFIG: {
      apiKey: 'AIzaSyCItzWhbPfswgUHBJLy7KcPxsACsJ4PNrk',
      authDomain: 'italian-artisan-stage-898c0.firebaseapp.com',
      databaseURL: 'https://italian-artisan-stage-898c0.firebaseio.com',
      projectId: 'italian-artisan-stage-898c0',
      storageBucket: 'italian-artisan-stage-898c0.appspot.com',
      messagingSenderId: '1002429327218',
      appId: '1:1002429327218:web:cbb8a47f7baefaf0d35feb',
    },
    SENTRY_ENV_NAME: 'local',
    CLEAROUT_WIDGET_ID: CLEAROUT_WIDGET_ID_NON_PROD,
  },
  development: {
    API_BASE_URL_V1: 'https://italian-artisan-server.onrender.com/api/v1/',
    API_BASE_URL_V2: 'https://api-italian-artisan.onrender.com/v1/',
    API_BASE_URL_V3: 'https://api-italian-artisan.onrender.com/v2/',
    API_BASE_URL_CATEGORIES: 'https://categories-service.onrender.com/',
    API_BASE_URL_ONBOARDING: 'https://onboarding-backend.onrender.com/api/',
    WEBSITE_BASE_URL: 'https://italian-artisan.com/',
    WEBAPP_BASE_URL: 'https://italian-artisan-webapp.onrender.com/',
    THANK_YOU_PAGE: 'https://italian-artisan.com/custom-signup-thank-you-page/',
    AUTH_APP_URL: 'https://auth-italian-artisan-stage.web.app/',
    FIREBASE_CONFIG: {
      apiKey: 'AIzaSyCItzWhbPfswgUHBJLy7KcPxsACsJ4PNrk',
      authDomain: 'italian-artisan-stage-898c0.firebaseapp.com',
      databaseURL: 'https://italian-artisan-stage-898c0.firebaseio.com',
      projectId: 'italian-artisan-stage-898c0',
      storageBucket: 'italian-artisan-stage-898c0.appspot.com',
      messagingSenderId: '1002429327218',
      appId: '1:1002429327218:web:cbb8a47f7baefaf0d35feb',
    },
    SENTRY_ENV_NAME: 'development',
    CLEAROUT_WIDGET_ID: CLEAROUT_WIDGET_ID_NON_PROD,
  },
  production: {
    API_BASE_URL_V1: 'https://italian-artisan.herokuapp.com/api/v1/',
    API_BASE_URL_V2: 'https://api-italian-artisan.herokuapp.com/v1/',
    API_BASE_URL_V3: 'https://api-italian-artisan.herokuapp.com/v2/',
    API_BASE_URL_CATEGORIES: 'https://categories-service.herokuapp.com/',
    API_BASE_URL_ONBOARDING: 'https://ia-onboarding-backend.herokuapp.com/api/',
    WEBSITE_BASE_URL: 'https://italian-artisan.com/',
    WEBAPP_BASE_URL: 'https://app.italian-artisan.com/',
    THANK_YOU_PAGE: 'https://italian-artisan.com/custom-signup-thank-you-page/',
    AUTH_APP_URL: 'https://account.italian-artisan.com/',
    FIREBASE_CONFIG: {
      apiKey: 'AIzaSyA3oDvnoboPjyXtomo2eoI6JYJPJ0oGIY4',
      authDomain: 'italian-artisan.firebaseapp.com',
      databaseURL: 'https://italian-artisan.firebaseio.com',
      projectId: 'italian-artisan',
      storageBucket: 'italian-artisan.appspot.com',
      messagingSenderId: '740092147048',
      appId: '1:740092147048:web:70f8f2ba41d5bee1b312dd',
    },
    SENTRY_ENV_NAME: 'production',
    CLEAROUT_WIDGET_ID: '4cb3369ee49f7367938952d27cee8bc4',
  },
};

export const environment =
  environments[process.env.REACT_APP_MODE ?? 'production'];
